__turbopack_context__.v({
  "accordionContent": "staff-card-module__Mhw6Hq__accordionContent",
  "accordionContentBio": "staff-card-module__Mhw6Hq__accordionContentBio",
  "accordionItem": "staff-card-module__Mhw6Hq__accordionItem",
  "accordionRoot": "staff-card-module__Mhw6Hq__accordionRoot",
  "accordionTrigger": "staff-card-module__Mhw6Hq__accordionTrigger",
  "accordionTriggerBio": "staff-card-module__Mhw6Hq__accordionTriggerBio",
  "card": "staff-card-module__Mhw6Hq__card",
  "cardImage": "staff-card-module__Mhw6Hq__cardImage",
  "cardPosition": "staff-card-module__Mhw6Hq__cardPosition",
  "cardText": "staff-card-module__Mhw6Hq__cardText",
  "cardTitle": "staff-card-module__Mhw6Hq__cardTitle",
  "caretIcon": "staff-card-module__Mhw6Hq__caretIcon",
  "imageDark": "staff-card-module__Mhw6Hq__imageDark",
  "imageLight": "staff-card-module__Mhw6Hq__imageLight",
  "imageWrapper": "staff-card-module__Mhw6Hq__imageWrapper",
  "slideDown": "staff-card-module__Mhw6Hq__slideDown",
  "slideUp": "staff-card-module__Mhw6Hq__slideUp",
  "socialLink": "staff-card-module__Mhw6Hq__socialLink",
  "socialLinks": "staff-card-module__Mhw6Hq__socialLinks",
});
